import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import {
  DealerSummaryRequest,
  DealerSummaryResponse,
  MultiDealerSummaryRequest,
  MultiDealerSummaryResponse,
} from '../models/dealer-summary.model';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class DealerSummaryService {
  constructor(private readonly http: HttpClient) {}

  getDealerSummary(
    requestPayload: DealerSummaryRequest
  ): Observable<DealerSummaryResponse> {
    const url = `/dealer-summary/get-summary`;
    console.log(requestPayload);
    return this.http.post<DealerSummaryResponse>(url, requestPayload);
  }

  getMultiDealerSummary(
    requestPayload: MultiDealerSummaryRequest
  ): Observable<MultiDealerSummaryResponse> {
    const url = `/dealer-summary/get-multi-summary`;
    console.log(requestPayload);
    return this.http.post<MultiDealerSummaryResponse>(url, requestPayload);
  }
}
